import "../stylesheets/PagesOverviewScreen.css";

import React from "react";
import Select from "react-select";
import Util from "../classes/Util";

import ScreenManager from "../manager/ScreenManager";
import PageManager from "../manager/PageManager";

import Header from "../components/Header";

import ListGroup from "react-bootstrap/ListGroup";
import Alert from "react-bootstrap/Alert";
import Tag from "../classes/Tag";

const pageManager = PageManager.instance;
const screenManager = ScreenManager.instance;

export default class PagesOverviewScreen extends React.PureComponent {

    /** @type {{ section: string }} */
    props;

    state = {
        tags: pageManager.hasFetchedShortPages() && pageManager[this.isReasonsScreen() ? "getGroupedTags" : "getAudiencesArray"](),
        pagesWithTags: pageManager.hasFetchedShortPages() && pageManager[this.isReasonsScreen() ? "getShortPagesWithSelectedTags" : "getShortPagesWithSelectedAudiences"](),
        /** @type {{ value: string, label: string } []} */
        regions: []
    }

    async componentDidMount() {
        if (!pageManager.hasFetchedShortPages()) {
            if (!await pageManager.refetchShortPages()) screenManager.showError("Die Seiten konnten nicht vom Server geladen werden!");
            if (!await pageManager.refetchTopicInfo()) screenManager.showError("Die Kategorien konnten nicht vom Server geladen werden!");
            this.updatePagesAndTags();
        }
    }

    render() {
        return (
            <div className="flexContainer secondaryColorBackground" >

                <Header title={pageManager.SECTIONS.get(this.props.section)} />

                <div id="reasonsScreen-contentContainer" className="flexContainer" >

                    { this.renderTags() }

                    <div className="spacerV-2em" />
                    <div className="spacerV-2em" />

                    { this.renderArticles() }

                </div>

                { this.isReasonsScreen() && 
                    <footer id="reasonsScreen-footerContainer" className="centeredItems" >
                        <h3>Meldung eines Misstandes</h3>

                        <div>Sie möchten unsere Beiträge ergänzen? <Alert.Link href={window.location.protocol + "//" + window.location.host + "/transparencyportal/leak"} >Hier</Alert.Link> gelangen Sie zum Meldeformular.</div>
                    </footer>
                }

            </div>
        );

    }

    renderTags() {
        return (
            <div className="flexContainer" >
                {
                    <ListGroup className="reasonsScreen-listGroup" >
                        <ListHeader title="Kategorien" />
                        
                        <Select
                            placeholder="Bundesland auswählen"
                            options={Util.REGIONS}
                            defaultValue={this.state.regions}
                            onChange={regions => this.setState({ regions })}
                            isMulti
                        />
                        
                        { !this.state.tags ? <div className="spinner-border" role="status" /> :
                            this.state.tags.map( (tagCategory, index) => tagCategory instanceof Tag ?
                                <ListItem
                                    title={tagCategory.name}
                                    active={tagCategory.selected}
                                    key={"tag:"+tagCategory.id}
                                    onClick={() => {
                                        pageManager[this.isReasonsScreen() ? "toggleTag" : "toggleAudience"]( tagCategory.id )
                                        this.updatePagesAndTags();
                                    }}
                                />
                            :
                                <ListGroupItem key={"category:"+index} title={tagCategory.name} >
                                    { tagCategory.tags.map( tag => 
                                            <ListItem
                                                title={tag.name}
                                                active={tag.selected}
                                                key={"tag:"+tag.id}
                                                onClick={() => {
                                                    pageManager[this.isReasonsScreen() ? "toggleTag" : "toggleAudience"]( tag.id )
                                                    this.updatePagesAndTags();
                                                }}
                                            />
                                        )
                                    }
                                </ListGroupItem>
                            )
                        }
                    </ListGroup>
                }
            </div>
        );
    }

    renderArticles() {
        return (    
            <div className="flexContainer" style={{ flex: 4 }} >
                {
                    <ListGroup className="reasonsScreen-listGroup">
                        <ListHeader title="Artikel" />
                        { !this.state.pagesWithTags ? <div className="spinner-border" role="status" /> :
                            this.state.pagesWithTags
                                .filter( page => this.state.regions.length === 0 || this.state.regions.findIndex( region => region.value === page.region ) !== -1 )
                                .map( page => (
                                    <ListItem
                                        key={"page:"+page.id}
                                        onClick={() => screenManager.pushScreen("Page", { id: page.id, section: this.props.section })}
                                        title={page.title}
                                        active
                                    />
                                ))
                        }
                    </ListGroup>
                }
            </div>
        );
    }

    updatePagesAndTags() {
        this.setState({
            tags: pageManager[this.isReasonsScreen() ? "getGroupedTags" : "getAudiencesArray"](),
            pagesWithTags: pageManager[this.isReasonsScreen() ? "getShortPagesWithSelectedTags" : "getShortPagesWithSelectedAudiences"]()
        })
    }

    isReasonsScreen() {
        return this.props.section === pageManager.SECTION_IDS.Reasons;
    }

}

class ListGroupItem extends React.PureComponent {

    state = {
        open: false
    }

    render() {

        return (
            <>
                <div
                    className={[
                        "quaternaryTheme",
                        "reasonsScreen-listItemLayout",
                        "reasonsScreen-listItem",
                        "reasonsScreen-listItemInactive"
                    ].join(" ")}
                    onClick={() => this.setState({ open: !this.state.open })}
                >
                    { this.props.title }
                </div>
                <div className="reasonsScreen-listGroupItemChildContainer" >{ this.state.open ? this.props.children : null }</div>
            </>
        );

    }

}

class ListItem extends React.PureComponent {

    render() {

        return (
            <div
                className={[
                    "quaternaryTheme",
                    "reasonsScreen-listItemLayout",
                    "reasonsScreen-listItem",
                    this.props.active ? "" : "reasonsScreen-listItemInactive"
                ].join(" ")}
                onClick={this.props.onClick}
            >
                { this.props.title }
            </div>
        );

    }

}

class ListHeader extends React.PureComponent {

    render() {

        return (
            <div className="reasonsScreen-listHeader reasonsScreen-listItemLayout tertiaryTheme">
                { this.props.title }
            </div>
        );

    }

}